import React from "react";
import { Menu, Bell } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { TID } from "@/constants/testIds";
import { useAuth } from "@/context/AuthContext";

export function Header({ title, subtitle, onOpenMobile }) {
  const { user } = useAuth();
  return (
    <header className="glass sticky top-0 z-30 flex h-16 items-center justify-between gap-4 border-b border-border/60 px-4 sm:px-6">
      <div className="flex items-center gap-3">
        <button
          data-testid={TID.mobileMenuButton}
          onClick={onOpenMobile}
          aria-label="Open menu"
          className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-secondary/40 text-foreground lg:hidden"
        >
          <Menu className="h-5 w-5" />
        </button>
        <div className="leading-tight">
          <h1 className="font-heading text-lg font-semibold tracking-tight sm:text-xl">{title}</h1>
          {subtitle && <p className="hidden text-xs text-muted-foreground sm:block">{subtitle}</p>}
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <button
          aria-label="Notifications"
          className="relative flex h-9 w-9 items-center justify-center rounded-full border border-border bg-secondary/40 text-foreground transition-colors hover:bg-secondary"
        >
          <Bell className="h-[18px] w-[18px]" />
          <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-gold ring-2 ring-card" />
        </button>
        <ThemeToggle />
        <div className="hidden items-center gap-2 rounded-full border border-border bg-secondary/40 py-1 pl-1 pr-3 sm:flex">
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-lux-emerald/15 font-heading text-xs font-semibold text-lux-emerald">
            {(user?.name || "SA").slice(0, 2).toUpperCase()}
          </div>
          <span className="text-sm font-medium">{user?.name || "SUPER ADMIN"}</span>
        </div>
      </div>
    </header>
  );
}
